'use strict'

export const Utils = {
    addProperty(obj, prop, propKey, propValue = null) {
        let objClone = JSON.parse(JSON.stringify(obj))
        if (objClone[prop] && Array.isArray(objClone[prop])) {
            const id = objClone[prop].length + 1
            const key = propKey
            const value = propValue || propKey
            objClone[prop].push({ id, key, value })
        } else {
            console.warn(`${prop} was not found`)
        }
        return objClone
    },
    removeProperty(obj, prop, index) {
        let objClone = JSON.parse(JSON.stringify(obj))
        if (objClone[prop] && Array.isArray(objClone[prop])) {
            let items = objClone[prop]
            items.splice(index, 1)
        } else {
            console.warn(`${prop} was not found`)
        }
        return objClone
    },
    createMappings(obj, maps) {
        let mappings = {}
        let id
        for (let prop in obj) {
            if (maps.indexOf(prop) !== -1) {
                id = 1
                mappings[prop] = []
                const propContents = obj[prop]
                if (!propContents) {
                    continue
                }
                for (const [key, value] of Object.entries(propContents)) {
                    mappings[prop].push({ id, key, value })
                    id++
                }
            }
        }
        return mappings
    },
    unmap(mappings) {
        let unmapped = {}
        for (const map in mappings) {
            let mapping = mappings[map]
            if (!mapping.length) {
                switch (map) {
                    case 'available_languages':
                    case 'tracked_metrics':
                        unmapped[map] = []
                        break;

                    default:
                        unmapped[map] = {}
                        break;
                }
                continue
            }

            for (let i = 0; i < mapping.length; i++) {
                let mapItem = mapping[i]
                switch (map) {
                    case 'available_languages':
                    case 'tracked_metrics':
                        if (!unmapped[map] || !Array.isArray(unmapped[map])) {
                            unmapped[map] = []
                        }
                        if (mapItem.value) {
                            unmapped[map].push(mapItem.value)
                        }
                        break;

                    default:
                        if (!unmapped[map]) {
                            unmapped[map] = {}
                        }

                        if (mapItem.key && mapItem.value) {
                            unmapped[map][mapItem.key] = mapItem.value
                        } else {
                            delete unmapped[map][mapItem.key]
                        }
                        break;
                }
            }
        }
        return unmapped
    },
    validateSchema(component, schema, obj, field, callback, notify) {
        schema.validate(obj, { abortEarly: false })
        .then(() => {
            if (callback) {
                callback(true)
            }
        }).catch(err => {
            if (notify) {
                component.$notify({
                    title: 'Validation Error',
                    text: 'Please fix any errors noted above',
                    type: 'error'
                })
            }
            err.inner.forEach(error => {
                if (field && error.path === field) {
                    component.errors[error.path] = error.message
                    return
                }
                component.errors[error.path] = error.message
            })

            if (callback) {
                callback(false)
            }
            return Promise.reject(err)
        })
    },
    notifyError(component, error) {
        let text = 'An unknown error occurred'
        if (error.message) {
            text = error.message
        } else if (error.status) {
            text = `Server returned HTTP Status ${error.status}`
        }
        component.$notify({
            title: 'Error',
            text: text,
            type: 'error'
        })
    },
    getStack() {
        try {
            throw new Error();
        } catch(e) {
            console.log(e.stack);
        }
    }
}
